import React from 'react';
const SPARKLE_PATH = 'M8.7392 3.95325C8.80091 3.67456 9.19822 3.67456 9.25993 3.95325L9.63755 5.65874C9.93641 7.00854 10.9906 8.06272 12.3404 8.36159L14.0459 8.7392C14.3246 8.80091 14.3246 9.19822 14.0459 9.25993L12.3404 9.63755C10.9906 9.93641 9.93641 10.9906 9.63755 12.3404L9.25993 14.0459C9.19822 14.3246 8.80091 14.3246 8.7392 14.0459L8.36159 12.3404C8.06272 10.9906 7.00854 9.93641 5.65874 9.63755L3.95325 9.25993C3.67456 9.19822 3.67456 8.80091 3.95325 8.7392L5.65874 8.36159C7.00854 8.06272 8.06272 7.00854 8.36159 5.65874L8.7392 3.95325Z';
export const SparkleIcon = _ref => {
  let {
    svgClassName
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: 'block',
      flexShrink: 0
    },
    className: svgClassName
  }, /*#__PURE__*/React.createElement("path", {
    d: SPARKLE_PATH,
    fill: "var(--eclipse-text-color)"
  }));
};
//# sourceMappingURL=SparkleIcon.js.map